
import React from 'react'

const Spinner: React.FC = () => {
  return (
    <svg className="spinner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 75 75">
      <defs>
        <linearGradient id="a" x1="37.5" y1="75" x2="37.5" gradientUnits="userSpaceOnUse">
          <stop offset=".1" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="b" y1="37.5" x2="41.25" y2="37.5" gradientUnits="userSpaceOnUse">
          <stop offset="0" />
          <stop offset="1" />
        </linearGradient>
      </defs>
      <path d="M37.5 0A37.5 37.5 0 1 0 75 37.5 37.5 37.5 0 0 0 37.5 0zm0 67.5a30 30 0 1 1 30-30 30 30 0 0 1-30 30z" fill="url(#a)" />
      <path d="M37.5 0a37.5 37.5 0 0 0 0 75v-7.5a30 30 0 0 1 0-60 3.8 3.8 0 0 0 3.8-3.7A3.8 3.8 0 0 0 37.5 0z" fill="url(#b)" />
    </svg>
  );
};

export default Spinner
